import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import useHttpHook from "../../../Hooks/HttpHook";
import { CancelEvent } from "../../../utils/ApiConstant";
import MainComponentWrapper from "../MainComponentWrapper";
import Input from "../../UiElement/FormElement/Input";
import { useForm } from "react-hook-form";
import ModalWrapper from "../Portals/ModalWrapper";

export const CancelRequestModal = ({
  eventId,
  onClose,
  amount,
  show,
  getEvents,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [params, setParams] = useState({});
  const [loading, sendRequest, error] = useHttpHook();
  const handleDeleteEvent = async (data) => {
    try {
      let response = await sendRequest(`${CancelEvent}/${eventId}`, {
        method: "post",
        data: {
          ...data,
          amount,
        },
      });
      if (response.status === 1) {
        getEvents();
        onClose();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleChange = (name, value) => {
    setParams((prev) => {
      return { ...prev, [name]: value };
    });
  };
  return (
    <>
      <MainComponentWrapper loading={loading} errorInfo={error}>
        <Modal
          show={show}
          onHide={onClose}
          dialogClassName="event-cancel-modal-dialog"
          contentClassName="event-cancel-modal"
        >
          {amount > 0 ? (
            <>
              <Modal.Header closeButton className="event-cancel-modal-header">
                <Modal.Title>Cancel Event Payment</Modal.Title>
              </Modal.Header>
              <Modal.Body className="event-cancel-modal-body">
                <p className="event-cancel-modal-note">
                  A refund of USD {amount} is due. Enter the card to charge.
                </p>
                <div className="event-cancel-modal-fields">
                  <Input
                    ValidationArr={[{ Type: "required" }]}
                    CustomFormGroupCls="event-cancel-modal-field"
                    InputClassName="event-cancel-modal-input"
                    LabelCls="event-cancel-modal-label"
                    element="text"
                    Label="Card Number"
                    FieldName="cardNumber"
                    Register={register}
                    Errors={errors}
                    placeholder="1234 1234 1234 1234"
                  />
                  <div className="event-cancel-modal-field-row">
                    <Input
                      ValidationArr={[{ Type: "required" }]}
                      CustomFormGroupCls="event-cancel-modal-field"
                      InputClassName="event-cancel-modal-input"
                      LabelCls="event-cancel-modal-label"
                      element="text"
                      Label="Card Expiry"
                      FieldName="cardExpiry"
                      Register={register}
                      Errors={errors}
                      placeholder="MM/YY"
                    />
                    <Input
                      ValidationArr={[{ Type: "required" }]}
                      CustomFormGroupCls="event-cancel-modal-field"
                      InputClassName="event-cancel-modal-input"
                      LabelCls="event-cancel-modal-label"
                      Label="CVV"
                      element="text"
                      FieldName="cvv"
                      Register={register}
                      Errors={errors}
                      placeholder="CVV"
                    />
                  </div>
                  <Input
                    ValidationArr={[{ Type: "required" }]}
                    CustomFormGroupCls="event-cancel-modal-field"
                    InputClassName="event-cancel-modal-input"
                    LabelCls="event-cancel-modal-label"
                    element="text"
                    FieldName="name"
                    Label="Name"
                    Register={register}
                    Errors={errors}
                    placeholder="Please enter your name..."
                  />
                  <button
                    type="button"
                    onClick={handleSubmit(handleDeleteEvent)}
                    disabled={loading}
                    className="event-cancel-modal-btn-ok event-cancel-modal-btn-pay"
                  >
                    Pay USD {amount}
                  </button>
                </div>
              </Modal.Body>
            </>
          ) : (
            <>
              <Modal.Header closeButton className="event-cancel-modal-header">
                <Modal.Title>Cancel Event</Modal.Title>
              </Modal.Header>
              <Modal.Body className="event-cancel-modal-body">
                <p>Are you sure you want to cancel the event?</p>
              </Modal.Body>
              <Modal.Footer className="event-cancel-modal-footer">
                <Button
                  className="event-cancel-modal-btn-dismiss"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  className="event-cancel-modal-btn-ok"
                  onClick={handleSubmit(handleDeleteEvent)}
                  disabled={loading}
                >
                  Ok
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </MainComponentWrapper>
    </>
  );
};
